import React from 'react';
import OppourtunityManagement from "../OppourtunityManagement"
import NetworkDetector from "../HigherOrderComponents/NetworkDetector";
import SubAdminSideBar from '../SubAdminSideBar';
import HelpAndSupport from '../HelpAndSupport';

const HelpAndSupportsubAdminPage = () => {
  return (
    <React.Fragment>
    <SubAdminSideBar>
       <HelpAndSupport />
    </SubAdminSideBar>
  </React.Fragment>
  );
}

export default NetworkDetector(HelpAndSupportsubAdminPage);
